<p-toast [style]="{marginTop: '80px'}"></p-toast>
<div>
  <div class="message-action-buttons" role="toolbar" aria-label="Conversation actions">
    @if (inbox?.msgFolder !== 2) {
      <button pButton label="Archive" class="p-button-sm conv-action-btn-archive"
        aria-label="Archive this conversation"
        (click)="archiveMsg(inbox)">
      </button>
    }
    @if (inbox) {
      <button pButton label="Add Task" class="p-button-sm conv-action-btn-task"
        aria-label="Add a task for this conversation"
        (click)="openCreateTask(inbox)">
      </button>
    }
    @if (inbox) {
      <button pButton label="Tape Chart" class="p-button-sm conv-action-btn-tape"
        aria-label="Open tape chart for this conversation"
        (click)="openTapChart(inbox)">
      </button>
    }
    <div class="message-action-buttons" role="toolbar" aria-label="Conversation actions">
      @if (inbox?.msgFolder !== 2) {
        <button pButton label="Archive" class="p-button-sm conv-action-btn-archive"
          aria-label="Archive this conversation"
          (click)="archiveMsg(inbox)">
        </button>
      }
      @if (inbox) {
        <button pButton label="Add Task" class="p-button-sm conv-action-btn-task"
          aria-label="Add a task for this conversation"
          (click)="openCreateTask(inbox)">
        </button>
      }
      @if (inbox) {
        <button pButton label="Tape Chart" class="p-button-sm conv-action-btn-tape"
          aria-label="Open tape chart for this conversation"
          (click)="openTapChart(inbox)">
        </button>
      }
    </div>
  </div>
  <div class="conv-root">

    <!-- ══════════════════════ HEADER ══════════════════════ -->
    <div class="conv-header">
      <!-- Guest avatar -->
      <div class="conv-avatar">
        {{ (inbox?.senderName || inbox?.senderEmail || inbox?.senderMobileNum || '?').charAt(0).toUpperCase() }}
      </div>

      <!-- Subject + guest name -->
      <div class="conv-header-info">
        <div class="conv-header-subject" [title]="inbox?.subject">{{ inbox?.subject || 'Conversation' }}</div>
        <div class="conv-header-guest">{{ inbox?.senderName || '' }}</div>
      </div>

      <!-- Right: date + reservation badge -->
      <div class="conv-header-meta">
        <div class="conv-header-date">{{ inbox?.createDate | date:'MMM d, y, h:mm a' }}</div>
        @if (inbox?.topic == 100 && inbox?.topicId) {
          <a class="conv-rez-badge"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Open reservation ' + inbox?.topicId"
            [attr.aria-busy]="!!openingReservation[inbox?.topicId]"
            (click)="openReservation(inbox?.topicId)"
            (keydown.enter)="openReservation(inbox?.topicId)"
            (keydown.space)="openReservation(inbox?.topicId)">
            <i class="pi pi-calendar me-1" aria-hidden="true"></i>Rez #{{ inbox?.topicId }}
            @if (openingReservation[inbox?.topicId]) {
              <i class="pi pi-spin pi-spinner ms-1" aria-hidden="true"></i>
            }
          </a>
        }
      </div>

      <!-- Header actions -->
      <div class="conv-header-actions">
        <!-- <button type="button" class="conv-action-btn" (click)="openCreateTask()" title="Add Task">
        <i class="pi pi-check-square me-1"></i>Add Task
      </button> -->
      @if (showClose) {
        <button mat-icon-button [mat-dialog-close]="true" class="conv-close-btn"
          aria-label="Close conversation">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>

  <!-- ══════════════════════ CHANNEL INFO ══════════════════════ -->
  <div class="conv-channel-bar">
    <!-- SMS row -->
    @if (inbox?.senderMobileNum) {
      <div class="conv-channel-row">
        <span class="conv-origin-badge badge-sms">
          <i class="pi pi-mobile me-1"></i>SMS
        </span>
        <div class="conv-channel-detail">
          <span class="conv-channel-label">From</span>
          <span class="conv-channel-value">{{ inbox.senderMobileNum }}@if (inbox?.senderName) {
            <span class="conv-channel-name"> · {{ inbox.senderName }}</span>
          }</span>
        </div>
        @if (inbox?.msgRecipientAPIList?.[0]?.mobileNum) {
          <div class="conv-channel-detail">
            <span class="conv-channel-label">To</span>
            <span class="conv-channel-value">{{ inbox.msgRecipientAPIList[0].mobileNum }}</span>
          </div>
        }
      </div>
    }

    <!-- Email row -->
    @if (inbox?.senderEmail) {
      <div class="conv-channel-row">
        <span class="conv-origin-badge badge-email">
          <i class="pi pi-envelope me-1"></i>Email
        </span>
        <div class="conv-channel-detail">
          <span class="conv-channel-label">From</span>
          <span class="conv-channel-value">{{ inbox.senderEmail }}</span>
        </div>
        @if (inbox?.msgRecipientAPIList?.[0]?.email) {
          <div class="conv-channel-detail">
            <span class="conv-channel-label">To</span>
            <span class="conv-channel-value">{{ inbox.msgRecipientAPIList[0].email }}</span>
          </div>
        }
      </div>
    }

    <!-- Fallback -->
    @if (!inbox?.senderMobileNum && !inbox?.senderEmail) {
      <div class="conv-channel-row">
        <span class="conv-channel-label">From</span>
        <span class="conv-channel-value">{{ inbox?.senderName || '—' }}</span>
      </div>
    }
  </div>

  <!-- ══════════════════════ CHAT BODY ══════════════════════ -->
  <div class="conv-body">

    <!-- ── Reply composer (top) ────────────────────────────── -->
    @if (inbox?.senderMobileNum || inbox?.senderEmail) {
      <div [formGroup]="form1" class="conv-composer">
        <!-- Toolbar: type toggle + template -->
        <div class="conv-composer-toolbar">
          <div class="conv-type-toggle" role="group" aria-label="Reply channel">
            @if (inbox?.senderMobileNum) {
              <button type="button" class="conv-type-btn"
                [class.active]="showSmsReply"
                [attr.aria-pressed]="showSmsReply"
                aria-label="Toggle SMS reply"
                (click)="onReplyTypeChange('SMS')">
                <i class="pi pi-mobile" aria-hidden="true"></i> SMS
              </button>
            }
            @if (inbox?.senderEmail) {
              <button type="button" class="conv-type-btn"
                [class.active]="showEmailReply"
                [attr.aria-pressed]="showEmailReply"
                aria-label="Toggle Email reply"
                (click)="onReplyTypeChange('EMAIL')">
                <i class="pi pi-envelope" aria-hidden="true"></i> Email
              </button>
            }
          </div>
          <p-dropdown
            [showClear]="true"
            dropdownIcon="fa fa-caret-down"
            appendTo="body"
            [filter]="true"
            filterBy="name"
            class="conv-template-dropdown-inline flex-grow-1"
            [options]="msgTemplates"
            formControlName="msgTemplateId"
            optionLabel="name"
            optionValue="msgTemplateId"
            placeholder="Select Template"
            (onChange)="selectTemplate($event)">
          </p-dropdown>
        </div>
        <!-- SMS: attachment row -->
        @if (inbox?.senderMobileNum && showSmsReply) {
          <div class="conv-attach-row">
            <input #convFileInput id="conv-file-input" type="file" class="mail-file-input" multiple
              accept="image/*,video/*,audio/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              aria-label="Select files to attach"
              (change)="onFileSelected($event)">
              <button type="button" class="attach-btn conv-attach-btn"
                aria-label="Attach files"
                aria-controls="conv-file-input"
                (click)="convFileInput.click()">
                <i class="pi pi-paperclip" aria-hidden="true"></i>
                <span>Attach</span>
              </button>
              @if (uploadedFiles.length) {
                <div class="attachment-grid">
                  @for (file of uploadedFiles; track file; let i = $index) {
                    <div class="attachment-card conv-attachment-card">
                      <div class="attachment-card-thumb">
                        @if (isPdf(file)) {
                          <i class="pi pi-file-pdf"></i>
                        }
                        @if (!isPdf(file)) {
                          <i class="pi pi-file"></i>
                        }
                      </div>
                      <div class="text-start">
                        <div class="attachment-card-name" [title]="file.name">{{ file.name }}</div>
                        <div class="attachment-card-size">{{ formatFileSize(file.size) }}</div>
                      </div>
                      <div class="attachment-card-actions">
                        <button type="button" class="btn-attach-view"
                          [attr.aria-label]="'Preview ' + file.name"
                          (click)="viewAttachment(file)">
                          <i class="pi pi-eye" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn-attach-delete"
                          [attr.aria-label]="'Remove ' + file.name"
                          (click)="removeAttachment(i)">
                          <i class="pi pi-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!-- SMS: textarea + send -->
          @if (showSmsReply && inbox?.senderMobileNum) {
            <div class="conv-sms-input-row">
              <textarea
                pInputTextarea
                class="conv-chat-textarea"
                formControlName="mobileText"
                placeholder="Type an SMS message…"
                aria-label="SMS message body"
                rows="1"
                [autoResize]="true"
                (keydown.enter)="onChatInputEnter($event)">
              </textarea>
              <button
                type="button"
                class="conv-chat-send-btn"
                [disabled]="(!form1.get('mobileText')?.value?.trim() && !uploadedFiles?.length) || formLoading"
                [attr.aria-disabled]="(!form1.get('mobileText')?.value?.trim() && !uploadedFiles?.length) || formLoading"
                [attr.aria-busy]="formLoading"
                aria-label="Send SMS message"
                (click)="sendSmsMessage()">
                @if (!formLoading) {
                  <i class="pi pi-send" aria-hidden="true"></i>
                }
                @if (formLoading) {
                  <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                }
              </button>
            </div>
          }
          <!-- Email: subject + TinyMCE + send -->
          <div class="my-2">
            @if (showEmailReply && inbox?.senderEmail) {
              <div class="conv-email-subject-row">
                <i class="pi pi-tag conv-subject-icon"></i>
                <input
                  type="text"
                  pInputText
                  formControlName="emailSubject"
                  placeholder="Subject"
                  aria-label="Email subject"
                  class="conv-email-subject-field">
                </div>
                <editor
                  formControlName="emailHtml"
						[init]="{
							height: 240,
							base_url: '/tinymce',
							suffix: '.min',
							menubar: false,
							plugins: 'link image table code lists',
							toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | link'
						}"
                  class="w-100 conv-tinymce-editor">
                </editor>
                <div class="conv-email-send-row">
                  <button
                    type="button"
                    class="conv-email-send-btn"
                    [disabled]="!form1.get('emailHtml')?.value?.trim() || formLoading"
                    [attr.aria-disabled]="!form1.get('emailHtml')?.value?.trim() || formLoading"
                    [attr.aria-busy]="formLoading"
                    aria-label="Send email reply"
                    (click)="sendEmailMessage()">
                    @if (!formLoading) {
                      <i class="pi pi-send me-1" aria-hidden="true"></i>
                    }
                    @if (formLoading) {
                      <i class="pi pi-spin pi-spinner me-1" aria-hidden="true"></i>
                    }
                    Send Email
                  </button>
                </div>
              }
            </div>
            <!-- ── Divider between composer and messages ── -->
            @if (inbox?.senderMobileNum || inbox?.senderEmail) {
              <div class="conv-section-divider">
                <span>Conversation</span>
              </div>
            }
            <!-- ── Messages area ────────────────────────────────────── -->
            <div id="conv-chat-messages" class="conv-chat-messages"
              role="log"
              aria-live="polite"
              aria-label="Conversation messages"
              aria-atomic="false"
              (scroll)="onScrollDown($event)">
              <!-- Initial loading -->
              @if (loadingConversation && currentPage === 0 && conversationMessages.length === 0) {
                <div
                  class="conv-loading-state"
                  role="status"
                  aria-live="polite"
                  aria-busy="true">
                  <i class="pi pi-spin pi-spinner conv-loading-icon" aria-hidden="true"></i>
                  <span>Loading conversation…</span>
                </div>
              }
              <!-- Error state -->
              @if (conversationLoadError && !loadingConversation) {
                <div class="conv-empty-state" role="alert">
                  <i class="pi pi-exclamation-triangle conv-empty-icon" style="color: #e74c3c;" aria-hidden="true"></i>
                  <div class="conv-empty-title">Something went wrong</div>
                  <div class="conv-empty-sub">Could not load the conversation</div>
                  <button type="button" class="conv-view-email-btn mt-2" (click)="loadConversation(true)">
                    <i class="pi pi-refresh me-1" aria-hidden="true"></i>Reload Conversation
                  </button>
                </div>
              }
              <!-- Empty state -->
              @if (!loadingConversation && !conversationLoadError && conversationMessages.length === 0) {
                <div
                  class="conv-empty-state"
                  role="status">
                  <i class="pi pi-comments conv-empty-icon" aria-hidden="true"></i>
                  <div class="conv-empty-title">No messages yet</div>
                  <div class="conv-empty-sub">This conversation has no messages</div>
                </div>
              }
              <!-- Messages -->
              @for (message of conversationMessages; track message) {
                <div
                  class="conv-message"
                  [ngClass]="{'conv-sent': message.direction === 'OUTGOING', 'conv-received': message.direction !== 'OUTGOING'}">
                  <!-- Avatar for incoming -->
                  @if (message.direction !== 'OUTGOING') {
                    <div class="conv-msg-avatar"
                      [class.conv-avatar-email]="message.isEmailMsg">
                      {{ (message.senderName || inbox?.senderName || '?').charAt(0).toUpperCase() }}
                    </div>
                  }
                  <div class="conv-message-bubble" [ngClass]="{'conv-bubble-email': message.isEmailMsg}">
                    <!-- Sender name + time -->
                    <div class="conv-message-header">
                      <span class="conv-sender-name">
                        {{ message.direction === 'OUTGOING' ? 'You' : (message.senderName || message.mobileNumber || 'Guest') }}
                      </span>
                      <span class="conv-message-time">{{ formatMessageDate(message.messageDateTime || message.createDate) }}</span>
                    </div>
                    <!-- SMS Content -->
                    @if (!message.isEmailMsg) {
                      <div class="conv-message-content">{{ message.mobileText || '' }}</div>
                      @if (message.smsAttachments?.length) {
                        <div class="conv-message-attachments">
                          @for (att of message.smsAttachments; track att) {
                            <div class="conv-attachment-pill"
                              (click)="openSmsAttachment(att)" title="Open attachment">
                              <i class="pi pi-paperclip"></i>
                              <span class="conv-attachment-name">{{ att.fileName || att.filename || 'Attachment' }}</span>
                            </div>
                          }
                        </div>
                      }
                      <div class="conv-message-meta">
                        @if (message._sendStatus) {
                          <ng-container class="text-light">
                            @if (message._sendStatus === 'sending') {
                              <i class="pi pi-spin pi-spinner conv-status-icon conv-status-sending"
                              title="Sending..."></i>
                            }
                            @if (message._sendStatus === 'sent') {
                              <i class="pi pi-verified conv-status-icon conv-status-sent"
                              title="Sent"></i>
                            }
                            @if (message._sendStatus === 'failed') {
                              <i class="pi pi-times-circle conv-status-icon conv-status-failed"
                              title="Failed to send"></i>
                            }
                          </ng-container>
                        }
                        @if (!message._sendStatus && message.msgId && (message.msgRecipientId || message.msgReciepentId || message.msgRecipientAPIId)) {
                          @if (message.deliveredDate) {
                            <span title="Delivered - {{ message.deliveredDate | date: 'MM/dd/yyyy HH:mm a' }}"
                              class="conv-sms-status-icon">
                              <i class="pi pi-verified"></i>
                            </span>
                          }
                          @if (message.deferredDate) {
                            <span title="Deferred - {{ message.deferredDate | date: 'MM/dd/yyyy HH:mm a' }}"
                              class="conv-sms-status-icon">
                              <i class="pi pi-times-circle"></i>
                            </span>
                          }
                          <button type="button" class="conv-info-btn"
                            aria-label="View SMS delivery details"
                            (click)="openSmsInfo(message)">
                            <i class="pi pi-info-circle" aria-hidden="true"></i>
                          </button>
                        }
                      </div>
                      <!-- Unified action row (SMS) -->
                      @if (message.msgId) {
                        <div class="conv-bubble-actions">
                          <button type="button" class="conv-bubble-btn conv-bubble-btn--task"
                            aria-label="Add task for this message"
                            (click)="openTaskForMessage(message)">
                            <i class="pi pi-plus-circle" aria-hidden="true"></i>
                            Add Task
                          </button>
                          <button type="button" class="conv-bubble-btn conv-bubble-btn--archive"
                            [disabled]="archivingMsgIds.has(message.msgId)"
                            [attr.aria-busy]="archivingMsgIds.has(message.msgId)"
                            aria-label="Archive this message"
                            (click)="archiveMessage(message)">
                            @if (archivingMsgIds.has(message.msgId)) {
                              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                            }
                            @if (!archivingMsgIds.has(message.msgId)) {
                              <i class="pi pi-inbox" aria-hidden="true"></i>
                            }
                            {{ archivingMsgIds.has(message.msgId) ? 'Archiving…' : 'Archive' }}
                          </button>
                        </div>
                      }
                      <!-- Tags -->
                      @if (message.msgId) {
                        <div class="conv-bubble-tags">
                          <app-tag-join-select [tagSource]="120" [tagSourceId]="message.msgId" tagType="4"
                            (tagsSelectedEvent)="onConversationMessageTagsSelected(message.msgId, $event)"></app-tag-join-select>
                        </div>
                      }
                    }
                    <!-- Email Content -->
                    @if (message.isEmailMsg) {
                      @if (message.subject) {
                        <div class="conv-email-subject">
                          <i class="pi pi-envelope me-1"></i>{{ message.subject }}
                        </div>
                      }
                      <div class="conv-email-snippet">{{ message.emailSnippet }}</div>
                      @if (message.attachmentCount > 0) {
                        <div class="conv-email-attachment-count">
                          <i class="pi pi-paperclip me-1"></i>{{ message.attachmentCount }} attachment{{ message.attachmentCount > 1 ? 's' : '' }}
                        </div>
                      }
                      @if (message._sendStatus) {
                        <div class="conv-email-status-row">
                          @if (message._sendStatus === 'sending') {
                            <span class="conv-email-status sending">
                              <i class="pi pi-spin pi-spinner"></i> Sending...
                            </span>
                          }
                          @if (message._sendStatus === 'sent') {
                            <span class="conv-email-status delivered">
                              <i class="pi pi-verified"></i> Sent
                            </span>
                          }
                          @if (message._sendStatus === 'failed') {
                            <span class="conv-email-status bounced">
                              <i class="pi pi-times-circle"></i> Failed
                            </span>
                          }
                        </div>
                      }
                      @if (!message._sendStatus && message.direction === 'OUTGOING') {
                        <div class="conv-email-status-row">
                          @if (message.deliveredDate) {
                            <span class="conv-email-status delivered"
                              title="Delivered: {{ message.deliveredDate | date:'MM/dd/yyyy h:mm a' }}">
                              <i class="pi pi-check-circle"></i> Delivered
                            </span>
                          }
                          @if (message.openedDate) {
                            <span class="conv-email-status opened"
                              title="Opened: {{ message.openedDate | date:'MM/dd/yyyy h:mm a' }}">
                              <i class="pi pi-eye"></i> Opened
                            </span>
                          }
                          @if (message.bouncedDate) {
                            <span class="conv-email-status bounced"
                              title="Bounced: {{ message.bouncedDate | date:'MM/dd/yyyy h:mm a' }}">
                              <i class="pi pi-times-circle"></i> Bounced
                            </span>
                          }
                          @if (message.droppedDate) {
                            <span class="conv-email-status dropped"
                              title="Dropped: {{ message.droppedDate | date:'MM/dd/yyyy h:mm a' }}">
                              <i class="pi pi-ban"></i> Dropped
                            </span>
                          }
                          @if (message.deferredDate) {
                            <span class="conv-email-status deferred"
                              title="Deferred: {{ message.deferredDate | date:'MM/dd/yyyy h:mm a' }}">
                              <i class="pi pi-clock"></i> Deferred
                            </span>
                          }
                        </div>
                      }
                      <!-- Unified action row (Email) -->
                      @if (message.msgId) {
                        <div class="conv-bubble-actions">
                          <button type="button" class="conv-bubble-btn"
                            (click)="openFullEmail(message)"
                            [disabled]="loadingEmailMsgId === message.msgId || replyingEmailMsgId === message.msgId"
                            [attr.aria-busy]="loadingEmailMsgId === message.msgId"
                            aria-label="View full email">
                            @if (loadingEmailMsgId !== message.msgId) {
                              <i class="pi pi-eye" aria-hidden="true"></i>
                            }
                            @if (loadingEmailMsgId === message.msgId) {
                              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                            }
                            {{ loadingEmailMsgId === message.msgId ? 'Loading…' : 'View Full Email' }}
                          </button>
                          <button type="button" class="conv-bubble-btn conv-bubble-btn--reply"
                            (click)="openEmailReplyForMessage(message)"
                            [disabled]="loadingEmailMsgId === message.msgId || replyingEmailMsgId === message.msgId"
                            [attr.aria-busy]="replyingEmailMsgId === message.msgId"
                            aria-label="Reply to this email">
                            @if (replyingEmailMsgId !== message.msgId) {
                              <i class="pi pi-reply" aria-hidden="true"></i>
                            }
                            @if (replyingEmailMsgId === message.msgId) {
                              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                            }
                            {{ replyingEmailMsgId === message.msgId ? 'Replying…' : 'Reply' }}
                          </button>
                          <button type="button" class="conv-bubble-btn conv-bubble-btn--task"
                            aria-label="Add task for this email"
                            (click)="openTaskForMessage(message)">
                            <i class="pi pi-plus-circle" aria-hidden="true"></i>
                            Add Task
                          </button>
                          <button type="button" class="conv-bubble-btn conv-bubble-btn--archive"
                            [disabled]="archivingMsgIds.has(message.msgId)"
                            [attr.aria-busy]="archivingMsgIds.has(message.msgId)"
                            aria-label="Archive this email"
                            (click)="archiveMessage(message)">
                            @if (archivingMsgIds.has(message.msgId)) {
                              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                            }
                            @if (!archivingMsgIds.has(message.msgId)) {
                              <i class="pi pi-inbox" aria-hidden="true"></i>
                            }
                            {{ archivingMsgIds.has(message.msgId) ? 'Archiving…' : 'Archive' }}
                          </button>
                        </div>
                      }
                      <!-- Tags -->
                      @if (message.msgId) {
                        <div class="conv-bubble-tags">
                          <app-tag-join-select [tagSource]="120" [tagSourceId]="message.msgId" tagType="4"
                            (tagsSelectedEvent)="onConversationMessageTagsSelected(message.msgId, $event)"></app-tag-join-select>
                        </div>
                      }
                    }
                  </div>
                  <!-- Spacer avatar for sent (keeps bubbles right-aligned symmetrically) -->
                  @if (message.direction === 'OUTGOING') {
                    <div class="conv-msg-avatar-spacer"></div>
                  }
                </div>
              }
              <!-- Loading (pagination) -->
              @if (loadingConversation && currentPage > 0) {
                <div class="conv-status-row">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>Loading more…</span>
                </div>
              }
            </div>
          </div>
          }<!-- /.conv-body -->

          <!-- ══════════════════════ SMS DETAIL DIALOG ══════════════════════ -->
          <p-dialog
            header="SMS Details"
            [(visible)]="showSmsDetailDialog"
            [modal]="true"
            [style]="{ width: '480px' }"
            appendTo="body"
            [baseZIndex]="12000"
            [draggable]="false">
            @if (loadingSmsDetail) {
              <div class="text-center py-4">
                <i class="pi pi-spin pi-spinner" style="font-size:1.8rem; color:#007bff;"></i>
              </div>
            }
            @if (!loadingSmsDetail && selectedSmsDetail) {
              <div class="conv-sms-detail">
                @if (selectedSmsDetail._noTrackingId) {
                  <div class="mb-3 p-2" style="background:#fff3cd;border-radius:4px;font-size:0.85rem;">
                    Delivery status unavailable — this message has no Twilio tracking ID.
                  </div>
                }
                @if (selectedSmsDetail.trackingId) {
                  <div class="conv-detail-row"><span class="conv-detail-label">Tracking ID</span><span>{{ selectedSmsDetail.trackingId }}</span></div>
                }
                <div class="conv-detail-row"><span class="conv-detail-label">Msg ID</span><span>{{ selectedSmsDetail.msgId }}</span></div>
                @if (selectedSmsDetail.from) {
                  <div class="conv-detail-row"><span class="conv-detail-label">From</span><span>{{ selectedSmsDetail.from }}</span></div>
                }
                @if (selectedSmsDetail.to) {
                  <div class="conv-detail-row"><span class="conv-detail-label">To</span><span>{{ selectedSmsDetail.to }}</span></div>
                }
                @if (selectedSmsDetail.sentDate) {
                  <div class="conv-detail-row"><span class="conv-detail-label">Sent</span><span>{{ formatMessageDate(selectedSmsDetail.sentDate) }}</span></div>
                }
                <div class="conv-detail-row">
                  <span class="conv-detail-label">Status</span>
                  <span class="conv-detail-status">
                    @if (selectedSmsDetail._noTrackingId) {
                      <span class="text-muted">Not available</span>
                    } @else if (selectedSmsDetail.twilioStatus) {
                      {{ selectedSmsDetail.statusLabel }} <span class="text-muted">({{ selectedSmsDetail.twilioStatus }})</span>
                    } @else {
                      {{ selectedSmsDetail.statusLabel || 'Unknown' }}
                    }
                  </span>
                </div>
                @if (selectedSmsDetail.errorCode || selectedSmsDetail.errorMessage) {
                  <div class="conv-detail-row">
                    <span class="conv-detail-label">Error</span>
                    <span class="text-danger">{{ selectedSmsDetail.errorCode }} {{ selectedSmsDetail.errorMessage }}</span>
                  </div>
                }
                @if (selectedSmsDetail.numMedia) {
                  <div class="conv-detail-row"><span class="conv-detail-label">Media Count</span><span>{{ selectedSmsDetail.numMedia }}</span></div>
                }
                @if (selectedSmsDetail.mobileText) {
                  <div class="conv-detail-row conv-detail-message">
                    <span class="conv-detail-label">Message</span>
                    <span style="white-space:pre-wrap;word-wrap:break-word;">{{ selectedSmsDetail.mobileText }}</span>
                  </div>
                }
                @if (selectedSmsDetail.smsAttachments?.length) {
                  <div class="conv-detail-row">
                    <span class="conv-detail-label">Attachments</span>
                    <ul class="conv-detail-attachments">
                      @for (att of selectedSmsDetail.smsAttachments; track att) {
                        <li>
                          <a href="{{ att.mediaUrl }}" target="_blank">{{ att.filename || 'Attachment' }}</a>
                          <span class="text-muted ms-1">({{ att.contentType }})</span>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
          </p-dialog>

        </div>
